$(function () {
    console.log('start nav');

    let $header = $('#mainnav'),
        $timer,
        $dekstopNav = $('#mainnav .nav'),
        $dekstopNavItems = $('#mainnav .nav > .item .nowrap'),
        $navHead = $('.nav .head'),
        $mobNavItem = $('.mob-nav .item');


    $dekstopNavItems.on('mouseenter', function () {
        $timer = setTimeout(() => {
            $parent = $(this).parents('.item');

            $header.addClass('active');
            $parent.siblings().removeClass('show-menu');
            $parent.addClass('show-menu');
        }, 150);
    });

    $dekstopNavItems.on('mouseleave', function () {
        clearTimeout($timer);
    });

    $dekstopNav.on('mouseleave', function () {
        $header.removeClass('active');
        $dekstopNavItems.parents().removeClass('show-menu');
    })

    $('.mobile-menu').on('click', function () {
        $('.mobile-menu').toggleClass('animate');
        $('.mobile-menu .bar').toggleClass('animate');
        $('nav.nav').toggleClass('animate');
        $('header.header').toggleClass('animate');

        $navHead.each(function () {
            let tr = $(this).data('target');
            $(tr).hasClass('open') ? $(tr).css({ '--h': `${$(tr).find('.body').innerHeight()}px` }) : $(tr).css({ '--h': 0 });
        })

        if ($(window).width() < 768) {
            $($body).toggleClass('modal-open');
        }
    });
    $(window).on('resize', function () {
        $('.mobile-menu').removeClass('animate');
        $('.mobile-menu .bar').removeClass('animate');
        $('.nav.nav').removeClass('animate');
        $('header.header').removeClass('animate');

        // if ($(window).width() < 768) {
        //     $('.modal').removeClass('open');
        //     $($body).removeClass('modal-open');
        // }

    });

    if ($(window).width() < 1280) {
        $('.mob-nav .item .nowrap').click(function () {
            $('nav.nav .item').removeClass('active');
            $(this).parent().addClass('active');
            $($(this).data('nav')).addClass('active');
        });
    }

    if ($('.nav .head[data-target]')[0]) {

        $navHead.each(function () {
            let tr = $(this).data('target');
            $(tr).hasClass('open') ? $(tr).css({ '--h': `${$(tr).find('.body').innerHeight()}px` }) : $(tr).css({ '--h': 0 });
        })

        $navHead.click(function () {
            $($(this).data('target')).hasClass('open') ? $(this).trigger('hide.bs.target') : $(this).trigger('shown.bs.target');
        })

        $navHead.on('shown.bs.target', function () {
            let tr = $(this).data('target');
            $(tr).addClass('open').css({ '--h': `${$(tr).find('.body').innerHeight()}px` });
            $(this).addClass('open');
        })

        $navHead.on('hide.bs.target', function () {
            $($(this).data('target')).css({ '--h': 0 }).removeClass('open');
            $(this).removeClass('open');
        })

        $mobNavItem.click(function () {
            let $head = $($(this).find('.nowrap').data('nav')).find('.head');
            $head.each(function () {
                let tr = $(this).data('target');
                $(tr).hasClass('open') ? $(tr).css({ '--h': `${$(tr).find('.body').innerHeight()}px` }) : $(tr).css({ '--h': 0 });
            })
        })

        setTimeout(() => {

        }, 0);

    }

    if (window.innerWidth < 1280) {
        // console.log(navigator.userAgent);
        if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
            // console.log('iphone');
            $('.appStore').css('display', 'block');
        } else if (navigator.userAgent.match(/Android/i)) {
            // console.log('android');
            $('.gPlay').css('display', 'block');
        } else {
            console.log('other');
            $('.appStore').css('display', 'block');
            $('.gPlay').css('display', 'block');
            // $('.dirDown').css('display', 'block');
        }
    }

    //active nav load page

    const navItems = {
        'home': '.personal',
        'private-client': '.personal',
        'faq': '.personal',
        'opacc': '.personal',
        'services': '.personal',
        'business': '.business',
        'entr': '.business',
        'connectApp': '.app',
        'fees': '.fees',
        'loyalty': '.loyalty',
        'vcc': '.loyalty',
        'company': '.about',
        'group': '.about',
        'structure': '.about',
        'reports': '.about',
        'news': '.about',
        'tecon': '.about',
        'docs': '.about',
        'offices': '.about',
        'contact': '.about'
    };

    for (let bodyClass in navItems) {

        if ($body.hasClass(bodyClass)) {
            $('header.header .nav .item').removeClass('active');

            console.log($body.hasClass(bodyClass));
            $(`.nav .item${navItems[bodyClass]}`).addClass('active');
            $(`.nav .item [data-nav="${navItems[bodyClass]}"]`).parent().addClass('active');
            break;
        }
    }


});